import React, { Component } from 'react';
import { Alert } from 'antd';
import { connect } from 'dva';
import TreeList from '../components/Tree/index';
import RoleList from '../components/RoleList/index';
// import ClassMasterModal from './components/ClassMasterModal';

@connect(({ roleManagement }) => ({
  ...roleManagement,
}))
class Role extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
    };

    this.handleVisibleChange = this.handleVisibleChange.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'roleManagement/fetchSchoolTreeList',
    });
  }

  // 改变设置班主任modal显示状态
  handleVisibleChange(status = true) {
    this.setState({
      visible: status,
    });

    if (status === false) {
      const { dispatch, currentselectTreeNode } = this.props;

      if (currentselectTreeNode) {
        dispatch({
          type: 'roleManagement/fetchDeptRoleList',
          params: {
            deptId: currentselectTreeNode.deptId,
            deptType: currentselectTreeNode.deptType,
          },
        });
      }
    }
  }

  render() {
    // const { visible } = this.state;
    return (
      <div style={{ height: '100%', overflowY: 'scroll' }}>
        <Alert
          message="使用说明"
          description="请根据实际情况进行部门的岗位设置，岗位设置后将同步展示到部门管理的部门岗位列表，以及通讯录的部门岗位列表中，岗位设置后用于完成公文流转等业务场景。如需新增岗位类型，请联系管理员协助。"
          type="info"
        />

        <div className="addressListTreeWrap">
          <div className="addressListTree">
            <TreeList />
          </div>
          <div className="contents">
            <div className="title">岗位设置</div>
            <RoleList />
          </div>
        </div>
      </div>
    );
  }
}

export default Role;
